module.exports = __webpack_public_path__ + "static/media/toilet-paper.373af880.svg";